module.exports = __webpack_public_path__ + "static/vista-explodida-ab9de846c841d645ab70cbe6f5f342a1.png";